import DarkModeTwoToneIcon from '@mui/icons-material/DarkModeTwoTone';
import LightModeTwoToneIcon from '@mui/icons-material/LightModeTwoTone';
import { IconButton, Tooltip } from '@mui/material';
import { useContext, useState } from 'react';
import { ThemeContext } from '../../../../../theme';

export function HeaderThemes() {
  const themeContext = useContext(ThemeContext);
  const initialTheme = localStorage.getItem('appTheme');

  const [element, setElement] = useState<any>(
    initialTheme === 'AvaniLightTheme' || !initialTheme ? <DarkModeTwoToneIcon /> : <LightModeTwoToneIcon />
  );

  function getTheme() {
    const appTheme = localStorage.getItem('appTheme');

    switch (appTheme) {
      case 'AvaniLightTheme': {
        return 'AvaniDarkTheme';
      }
      case 'AvaniDarkTheme': {
        return 'AvaniLightTheme';
      }
      default: {
        return 'AvaniDarkTheme';
      }
    }
  }

  const handleChange = (): void => {
    const theme = getTheme();
    localStorage.setItem('appTheme', theme);
    themeContext(theme);
    setElement(theme === 'AvaniLightTheme' ? <DarkModeTwoToneIcon /> : <LightModeTwoToneIcon />);
  };

  return (
    <>
      <Tooltip arrow title="Theme mode">
        <IconButton color="primary" onClick={handleChange}>
          {element}
        </IconButton>
      </Tooltip>
    </>
  );
}
